import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import styled from 'styled-components';
import { getThemeProp } from 'theme';

import DropdownItem from 'components/DropdownItem';

const activeStyling = ({ isActive = false }) =>
  isActive &&
  `
  &:before {
    content: 'a';
    position: absolute;
    top: 0;
    left: 10px;
    font-family: omilia-nlu-studio-v2;
  }
`;

const Container = styled(DropdownItem)`
  line-height: 30px;
  padding: 0 27px;
  position: relative;
  font-weight: normal;

  &:hover,
  &:active,
  &:focus {
    background-color: ${getThemeProp('colors.havelockBlue')};
    color: #fff;
  }
  ${activeStyling}
`;

const SortingMenuItem = ({ handleClick, isActive, item }) => {
  const onClick = () => handleClick(item);

  return (
    <Container
      data-test={`item-${kebabCase(item.label)}`}
      isActive={isActive}
      onClick={onClick}
    >
      {item.label}
    </Container>
  );
};

SortingMenuItem.propTypes = {
  handleClick: PropTypes.func,
  isActive: PropTypes.bool,
  item: PropTypes.shape({
    label: PropTypes.string,
  }),
};

export default SortingMenuItem;
